import { Component, OnInit, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { CommonService } from 'src/app/Global-Services/common.service';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { AppTokenHandler, HTTPStatus } from 'src/app/Global-Services/app-token-handler';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { GlobalVariable } from 'src/app/Variable/global-variable';
import { NgModel } from '@angular/forms';

@Component({
  selector: 'app-create-finance-user-mapping',
  standalone: false,
  templateUrl: './create-finance-user-mapping.component.html',
  styleUrl: './create-finance-user-mapping.component.css'
})

export class CreateFinanceUserMappingComponent implements OnInit {

  ErrorMessage = [];
  EmployeeName: string[];
  filteredEmployeeSingle: any [] =[];
  CompetencyList: String[];
  MargentSegmentList: String[];
  EmployeeList = {
    Employee: null,
    EmployeeGPN: null
  };
  FinanceUserMappingList = {
    ID: 0,
    EmployeeName: '',
    EmployeeGPN:'',
    ServiceLine: '',
    IsActive: true,
    CurrentUserGPN: '',
    EncryptID: '',
    Competency: '',
    MargentSegment: '',
  };
  ServiceLineList: String[];
  selectedOptions: string[] = [];
  isLoading: boolean =false;

 @ViewChild('txtEmployeeGPN') txtEmployeeGPN?: NgModel;

  constructor(public route: ActivatedRoute, private confirmBox: ConfirmationService,
    public gService: CommonService, public datepipe: DatePipe, private gVariable: GlobalVariable,
    private appTokenHandler: AppTokenHandler, private _Location: Location, public dialog: MatDialog, private _router: Router,
    private el: ElementRef,private cd: ChangeDetectorRef) { }


   async ngOnInit() {
    this.filteredEmployeeSingle = [];
    this.FinanceUserMappingList.EncryptID = this.route.snapshot.paramMap.get('ParamID');
    this.GetServiceLine();
    this.GetMarketSegmentForDropDown();
    await this.GetCompetencyForDropDown();
    this.FinanceUserMappingList.CurrentUserGPN = this.gVariable.User.UserGPN;
    if (this.FinanceUserMappingList.EncryptID != null && this.FinanceUserMappingList.EncryptID !== '') {
      this.GetFinanceUserMappingRecordDataByID(this.FinanceUserMappingList.EncryptID);
    }
  }

  async GetCompetencyForDropDown() {
    this.isLoading = true;
    const data: any = await this.gService.GetCompetencyForDropDown().toPromise();
      try{
      if (data != null) {
        if (data.length > 0) {
          this.CompetencyList = data;
        }
      }

      this.isLoading = false;
    }
    catch (error) {
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      }
    }
  }

  GetMarketSegmentForDropDown() {
    this.isLoading = true;
    this.gService.GetMarketSegmentForDropDown().subscribe((data: any) => {
      if (data != null) {
        if (data.length > 0) {
          this.MargentSegmentList = data;
        }
      }
      this.isLoading = false;
    },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  GetFinanceUserMappingRecordDataByID(ID: string)
  {
    this.isLoading = true;
    this.gService.GetFinanceUserMappingRecordDataByID(ID, this.FinanceUserMappingList.CurrentUserGPN).subscribe((data: any) => {
      if (data != null) {
        this.FinanceUserMappingList.ID = data[0].ID;
    this.FinanceUserMappingList.EmployeeName = data[0].EmployeeName,
    this.FinanceUserMappingList.EmployeeGPN = data[0].EmployeeGPN,
    this.FinanceUserMappingList.ServiceLine = data[0].ServiceLine,
    this.FinanceUserMappingList.MargentSegment = data[0].MarketSegmentID;
    this.FinanceUserMappingList.Competency = data[0].Competency == "-1" ? Number.parseInt(data[0].Competency) : data[0].Competency;
    this.FinanceUserMappingList.IsActive = data[0].IsActive;
    this.filteredEmployeeSingle = [
          {
            EmpFullName: data[0].EmpName + " (" + data[0].EmpEmail + ")",
          }
        ];
        this.EmployeeList.Employee = this.filteredEmployeeSingle[0];
    }
    this.isLoading = false;
    },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  GetEmpSearch(event: any, isGPNFilter: boolean = false) {
    const query = event.query;
    if ((query.length) >= 3) {
      this.gService.GetEmployeeSearch(query, this.gVariable.User.UserGPN).subscribe((data: any) => {
        if (data!=null && data.length > 0) {
          this.filteredEmployeeSingle = data;
        } else {
          this.EmployeeName = [];
          this.filteredEmployeeSingle = [];
        }
        this.isLoading = false;
      },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
          });
          this.gService.RedirectToErrorPage(2);
        });
    }
  }



  OnClearSendUser() {
    this.FinanceUserMappingList.EmployeeName = null;
    this.FinanceUserMappingList.EmployeeGPN = null;
  }

   SetSelectedEmpGPN(event: any) {
    this.FinanceUserMappingList.EmployeeName = event.value.EmpName;
    this.FinanceUserMappingList.EmployeeGPN = event.value.EmpGPN;
  }

  GetServiceLine() {
this.isLoading = true;
    this.gService.GetServiceLine().subscribe((data: any) => {
      if (data != null) {
        if (data.length > 0) {
          this.ServiceLineList = data;
        }
      }
      this.isLoading = false;
    },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  SubmitFinanceUserMapping()
  {
    this.isLoading = true;
     this.ErrorMessage = [];

      if (this.FinanceUserMappingList.EmployeeGPN == '' || this.FinanceUserMappingList.EmployeeGPN == null) {
      this.ErrorMessage.push({ Message: 'Please select Employee Name.' });
    }

    if (this.FinanceUserMappingList.ServiceLine == '' || this.FinanceUserMappingList.ServiceLine == null) {
      this.ErrorMessage.push({ Message: 'Please select ServiceLine.' });
    }

     if(this.FinanceUserMappingList.ID == 0 && this.FinanceUserMappingList.IsActive == false)
    {
      this.ErrorMessage.push({ Message: 'Please select Is Active.' });
    }

    if (this.FinanceUserMappingList.MargentSegment == '' || this.FinanceUserMappingList.MargentSegment == null) {
      this.ErrorMessage.push({ Message: 'Please select Margent Segment.' });
    }

    if (this.FinanceUserMappingList.Competency == '' || this.FinanceUserMappingList.Competency == null) {
      this.ErrorMessage.push({ Message: 'Please select Competency.' });
    }

     if (this.ErrorMessage.length > 0) {
      this.isLoading = false;
      return;
    }
    var boolReturn = false;
    boolReturn = confirm('Are you sure you want to submit this form?');
    if (boolReturn === false) {
      this.isLoading = false;
      return;
    }
    this.gService.PostService(this.FinanceUserMappingList, 'AccessMatrix/InsertAndUpdateFinanceUserMapping').subscribe(data => {
      if(data == "Success")
      alert("Data Submitted Successfully!");
      this._router.navigate(['/View/ViewFinanceUserMappingComponent']);
      this.isLoading = false;
    },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  onExit()
  {
    let confirm = false;
    const message = 'Are You Sure Want to Exit.';
    confirm = window.confirm(message);

    if (confirm) {
      this._router.navigate(['/View/ViewFinanceUserMappingComponent']);
    }
  }

  blockSpecialChar(event: any) {
    try {
      let k;

      if (event.key !== undefined) {
        k = event.key.charCodeAt(0);
      } else {
        document.all ? k = event.keyCode : k = event.which;
      }
      return ((k >= 65 && k <= 90) || (k >= 97 && k <= 122) || k === 8 || k === 32 || (k >= 48 && k <= 57) || k === 45);
    }
    catch (error) {
      console.log(error);
      return;
    }
  }

}
